import { DateInput, TextInput, Dropdown, FileUploader, useTranslator } from "@sia/style-guide";
import { useCallback, useContext, useEffect, useState } from "react";
import { WizarContext, singleEducationInfoActionCreator } from "contexts/WizardContext";
import GlobalContext from "contexts/GlobalContext";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import { initialWizardFormState } from "contexts/WizardContext";

const EducationInfo = ({ errors, setErrors }) => {
  const translate = useTranslator();
  const { language } = useContext(GlobalContext);
  const { state, dispatch } = useContext(WizarContext);
  let educationInfo = state.single.educationInfo;
  let educationInfoErrors = errors.single.educationInfo;
  let changState = useCallback((payload) => dispatch(singleEducationInfoActionCreator(payload)), [dispatch]);
  const resetInputFieldError = (property, error) => {
    setErrors((errorsState) => ({
      ...errorsState,
      single: {
        ...errorsState.single,
        educationInfo: { ...errorsState.single.educationInfo, [property]: error },
      },
    }));
  };

  const { user } = useContext(GlobalContext);

  const [studyTypes, setStudyTypes] = useState([]);
  useEffect(() => {
    if (user) {
      webPlatformAdapter.request("GET", "rpc/get_study_types_list", null, ({ data }) => {
        let studyTypes = data.map((e) => ({ id: e.id, label: e.name }));
        setStudyTypes(studyTypes);
      });
    }
  }, [user, language]);

  const [schools, setSchools] = useState([]);

  const setUserSession = (obj) => {
    pgAdapter.getWizardSession(({ data }) => {
      const updatedSession = { ...data, educationInfo: { ...data.educationInfo, ...obj } };
      pgAdapter.setWizardSession({ ...updatedSession });
    });
  };

  useEffect(() => {
    if (user) {
      pgAdapter.getWizardSession(({ data }) => {
        const defaultEducationInfo = { ...initialWizardFormState.single.educationInfo };
        const { educationInfo } = data;
        const {
          schoolName,
          studyType,
          graduationDate,
          diplomTitle,
          diplomFile,
          masterSchoolName,
          masterStudyType,
          masterGraduationDate,
          masterTitle,
          doctorateSchoolName,
          doctorateStudyType,
          doctorateGaduationDate,
          doctorateTitle,
        } = educationInfo || defaultEducationInfo;
        changState({
          schoolName,
          studyType,
          graduationDate,
          diplomTitle,
          diplomFile,
          masterSchoolName,
          masterStudyType,
          masterGraduationDate,
          masterTitle,
          doctorateSchoolName,
          doctorateStudyType,
          doctorateGaduationDate,
          doctorateTitle,
        });
      });
    }
  }, [user, changState]);

  useEffect(() => {
    if (user) {
      webPlatformAdapter.request("GET", "rpc/get_schools_list", null, ({ data }) => {
        let schools = data.map((e) => ({ id: e.id, label: e.name }));
        setSchools(schools);
      });
    }
  }, [user, language]);

  return (
    <div className="education-info-page">
      <p className="productive-heading-03 sia-text-02 sia-padding-03-top sia-padding-03-bottom">
        {translate("wizard.form.single.education.bachelor.label")}{" "}
      </p>
      <Dropdown
        id={"education-page-school"}
        label={translate("wizard.form.single.education.bachelor.school-name.label")}
        items={schools}
        value={educationInfo.schoolName}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("schoolName");
          changState({ schoolName: value });
          setUserSession({ schoolName: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={educationInfoErrors.schoolName}
        invalidText={educationInfoErrors.schoolName}
      />
      <Dropdown
        id={"education-page-study-type"}
        label={translate("wizard.form.single.education.bachelor.study-type.label")}
        items={studyTypes}
        value={educationInfo.studyType}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("studyType");
          changState({ studyType: value });
          setUserSession({ studyType: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={educationInfoErrors.studyType}
        invalidText={educationInfoErrors.studyType}
      />
      <DateInput
        onBlur={() => {
          if (educationInfo.graduationDate) {
            setUserSession({ graduationDate: educationInfo.graduationDate });
          }
        }}
        id={"education-page-graduation-date"}
        required={true}
        placeholder={"01.01.2000"}
        label={translate("wizard.form.single.education.bachelor.earn-date.label")}
        value={educationInfo.graduationDate}
        onChange={(event, value, error) => {
          resetInputFieldError("graduationDate", error);
          changState({ graduationDate: value });
        }}
        invalidPatternText={translate("form.input.error.invalid.with-example", { example: "d.m.yyyy" })}
        invalidText={educationInfoErrors.graduationDate}
      />

      <TextInput
        onBlur={() => {
          if (educationInfo.diplomTitle) {
            setUserSession({ diplomTitle: educationInfo.diplomTitle });
          }
        }}
        id={"education-page-diplom-title"}
        value={educationInfo.diplomTitle}
        onChange={(event, value) => {
          resetInputFieldError("diplomTitle");
          changState({ diplomTitle: value });
        }}
        label={translate("wizard.form.single.education.bachelor.diplom-title.label")}
        required={true}
        invalidPatternText={educationInfoErrors.diplomTitle}
        invalidText={educationInfoErrors.diplomTitle}
      />

      <FileUploader
        label={translate("wizard.form.single.education.bachelor.diplom.upload.label")}
        sizeLimit={500}
        sizeLimitUnit={"KB"}
        files={educationInfo.diplomFile}
        fileTypes={["pdf"]}
        buttonLabel={"wizard.form.single.education.bachelor.upload.button.label"}
        translate={translate}
        onChange={(event, files, error) => {
          resetInputFieldError("diplomFile");
          debugger;
          changState({ diplomFile: files });
          setUserSession({ diplomFile: files[0] });
          // setFiles(files);
          // setInvalidText(error);
        }}
        onRemove={(event, file, updatedFiles, error) => {
          resetInputFieldError("diplomFile");
          changState({ diplomFile: updatedFiles });
          // setFiles(updatedFiles);
          // setInvalidText(error);
        }}
        invalidText={educationInfoErrors.diplomFile}
      />

      <FileUploader
        label={translate("wizard.form.single.education.bachelor.diplom.reference.label")}
        sizeLimit={500}
        sizeLimitUnit={"KB"}
        files={educationInfo.referencesFile}
        fileTypes={["pdf"]}
        buttonLabel={"wizard.form.single.education.bachelor.upload.button.label"}
        translate={translate}
        onChange={(event, files, error) => {
          resetInputFieldError("referencesFile");
          changState({ referencesFile: files });
          // setFiles(files);
          // setInvalidText(error);
        }}
        onRemove={(event, file, updatedFiles, error) => {
          resetInputFieldError("referencesFile");
          changState({ referencesFile: updatedFiles });
          // setFiles(updatedFiles);
          // setInvalidText(error);
        }}
        invalidText={educationInfoErrors.referencesFile}
      />

      <p className="productive-heading-03 sia-text-02 sia-padding-03-top sia-padding-03-bottom">
        {translate("wizard.form.single.education.further-studies.label")}
      </p>
      <p className="productive-heading-01 sia-margin-03-bottom">{translate("wizard.form.single.education.further-studies.master.label")} </p>

      <Dropdown
        id={"education-page-master-school-Name"}
        required={true}
        items={schools}
        label={translate("wizard.form.single.education.bachelor.school-name.label")}
        value={educationInfo.masterSchoolName}
        onChange={(event, value, error) => {
          resetInputFieldError("masterSchoolName");
          changState({ masterSchoolName: value });
          setUserSession({ masterSchoolName: value });
        }}
        invalidPatternText={educationInfoErrors.masterSchoolName}
        invalidText={educationInfoErrors.masterSchoolName}
      />

      <Dropdown
        id={"education-page-master-study-type"}
        required={true}
        items={studyTypes}
        label={translate("wizard.form.single.education.bachelor.study-type.label")}
        value={educationInfo.masterStudyType}
        onChange={(event, value, error) => {
          resetInputFieldError("masterStudyType");
          changState({ masterStudyType: value });
          setUserSession({ masterStudyType: value });
        }}
        invalidPatternText={educationInfoErrors.masterStudyType}
        invalidText={educationInfoErrors.masterStudyType}
      />
      <DateInput
        onBlur={() => {
          if (educationInfo.masterGraduationDate) {
            setUserSession({ masterGraduationDate: educationInfo.masterGraduationDate });
          }
        }}
        id={"education-page-master-graduation-date"}
        required={true}
        label={translate("wizard.form.single.education.bachelor.earn-date.label")}
        value={educationInfo.masterGraduationDate}
        onChange={(event, value, error) => {
          resetInputFieldError("masterGraduationDate", error);
          changState({ masterGraduationDate: value });
        }}
        invalidPatternText={translate("form.input.error.invalid.with-example", { example: "d.m.yyyy" })}
        invalidText={educationInfoErrors.masterGraduationDate}
      />

      <TextInput
        onBlur={() => {
          if (educationInfo.masterTitle) {
            setUserSession({ masterTitle: educationInfo.masterTitle });
          }
        }}
        id={"education-page-master-diplom-title"}
        value={educationInfo.masterTitle}
        onChange={(event, value) => {
          resetInputFieldError("masterTitle");
          changState({ masterTitle: value });
        }}
        label={translate("wizard.form.single.education.bachelor.diplom-title.label")}
        required={true}
        invalidPatternText={educationInfoErrors.masterTitle}
        invalidText={educationInfoErrors.masterTitle}
      />

      <FileUploader
        label={translate("wizard.form.single.education.bachelor.diplom.upload.label")}
        sizeLimit={500}
        sizeLimitUnit={"KB"}
        files={educationInfo.masterFile}
        fileTypes={["pdf"]}
        buttonLabel={"wizard.form.single.education.bachelor.upload.button.label"}
        translate={translate}
        onChange={(event, files, error) => {
          resetInputFieldError("masterFile");
          changState({ masterFile: files });
          // setFiles(files);
          // setInvalidText(error);
        }}
        onRemove={(event, file, updatedFiles, error) => {
          resetInputFieldError("masterFile");
          changState({ masterFile: updatedFiles });
          // setFiles(updatedFiles);
          // setInvalidText(error);
        }}
        invalidText={educationInfoErrors.masterFile}
      />

      <p className="productive-heading-01 sia-margin-03-bottom">{translate("wizard.form.single.education.further-studies.doctoral.label")} </p>

      <Dropdown
        id={"education-page-doctorate-school-Name"}
        required={true}
        items={schools}
        label={translate("wizard.form.single.education.bachelor.school-name.label")}
        value={educationInfo.doctorateSchoolName}
        onChange={(event, value, error) => {
          resetInputFieldError("doctorateSchoolName");
          changState({ doctorateSchoolName: value });
          setUserSession({ doctorateSchoolName: value });
        }}
        invalidPatternText={educationInfoErrors.doctorateSchoolName}
        invalidText={educationInfoErrors.doctorateSchoolName}
      />

      <Dropdown
        id={"education-page-doctorate-study-type"}
        required={true}
        items={studyTypes}
        label={translate("wizard.form.single.education.bachelor.study-type.label")}
        value={educationInfo.doctorateStudyType}
        onChange={(event, value, error) => {
          resetInputFieldError("doctorateStudyType");
          changState({ doctorateStudyType: value });
          setUserSession({ doctorateStudyType: value });
        }}
        invalidPatternText={educationInfoErrors.doctorateStudyType}
        invalidText={educationInfoErrors.doctorateStudyType}
      />
      <DateInput
        onBlur={() => {
          if (educationInfo.doctorateGaduationDate) {
            setUserSession({ doctorateGaduationDate: educationInfo.doctorateGaduationDate });
          }
        }}
        id={"education-page-doctorate-graduation-date"}
        required={true}
        label={translate("wizard.form.single.education.bachelor.earn-date.label")}
        value={educationInfo.doctorateGaduationDate}
        onChange={(event, value, error) => {
          resetInputFieldError("doctorateGaduationDate", error);
          changState({ doctorateGaduationDate: value });
        }}
        invalidPatternText={translate("form.input.error.invalid.with-example", { example: "d.m.yyyy" })}
        invalidText={educationInfoErrors.doctorateGaduationDate}
      />

      <TextInput
        onBlur={() => {
          if (educationInfo.doctorateTitle) {
            setUserSession({ doctorateTitle: educationInfo.doctorateTitle });
          }
        }}
        id={"education-page-doctorate-diplom-title"}
        value={educationInfo.doctorateTitle}
        onChange={(event, value) => {
          resetInputFieldError("doctorateTitle");
          changState({ doctorateTitle: value });
        }}
        label={translate("wizard.form.single.education.bachelor.diplom-title.label")}
        required={true}
        invalidPatternText={educationInfoErrors.doctorateTitle}
        invalidText={educationInfoErrors.doctorateTitle}
      />

      <FileUploader
        label={translate("wizard.form.single.education.bachelor.diplom.upload.label")}
        sizeLimit={500}
        sizeLimitUnit={"KB"}
        files={educationInfo.doctorateFile}
        fileTypes={["pdf"]}
        buttonLabel={"wizard.form.single.education.bachelor.upload.button.label"}
        translate={translate}
        onChange={(event, files, error) => {
          resetInputFieldError("doctorateFile");
          changState({ doctorateFile: files });
          // setFiles(files);
          // setInvalidText(error);
        }}
        onRemove={(event, file, updatedFiles, error) => {
          resetInputFieldError("doctorateFile");
          changState({ doctorateFile: updatedFiles });
          // setFiles(updatedFiles);
          // setInvalidText(error);
        }}
        invalidText={educationInfoErrors.doctorateFile}
      />
    </div>
  );
};

export default EducationInfo;
